import { render, staticRenderFns } from "./fleet-column-identification.vue?vue&type=template&id=a4ad4632&scoped=true&"
import script from "./fleet-column-identification.vue?vue&type=script&lang=js&"
export * from "./fleet-column-identification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ad4632",
  null
  
)

export default component.exports